import Uri from "jsuri";
import type { ICompanyAccountInfoResponse, IPartnerTraining } from "../constants/apiconstants-hydra";
import Env from "../utils/env";
import { getUri } from "../utils/fetch";

export const getPartnerTrainingDetails = (
	limit: number,
	extraParams?: { fromDate?: string; toDate?: string; offset?: number },
): Promise<IPartnerTraining> => {
	const uri = new Uri(`${Env.hydraAPIURL}${Env.hydraAPIPrefix}/user/training/report`);
	uri.addQueryParam("limit", limit);
	if (extraParams?.fromDate !== undefined) {
		uri.addQueryParam("fromDate", extraParams.fromDate);
	}
	if (extraParams?.toDate !== undefined) {
		uri.addQueryParam("toDate", extraParams.toDate);
	}
	if (extraParams?.offset) {
		uri.addQueryParam("offset", extraParams.offset);
	}
	return getUri(uri);
};

export const getCompanyAccountInfo = (abortSignal?: AbortSignal): Promise<ICompanyAccountInfoResponse> => {
	const uri = new Uri(`${Env.hydraAPIURL}${Env.hydraAPIPrefix}/company/current/account-info`);
	const additionalParams: RequestInit = {};
	if (abortSignal) {
		Object.assign(additionalParams, { signal: abortSignal });
	}
	return getUri(uri, additionalParams);
};
